import _ from 'lodash';

export default {
  props: {
    value: {},
    editing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      model: this.value
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        this.model = _.defaultsDeep(this.value, this.defaultModel || {});
      }
    },
    model: {
      deep: true,
      // immediate: true,
      handler() {
        if (this.value != this.model) {
          this.$emit('input', this.model);
        }
      }
    }
  }
};
